import APILibrary, { GenerateResource } from './APILibrary';
import { EmployerProfileResource } from 'util/resources/EmployerProfile';
import { UserProfileResource } from 'util/resources/UserProfile';

/**
 * Relationship classes
 */
class NoteAttributes {
  id: string;
  body: string;
  createdAt: string;
  user_profile_id: string;
}

class NoteBelongsTo {
  employerProfile: () => EmployerProfileResource = () => new EmployerProfileResource();
  userProfile: () => UserProfileResource = () => new UserProfileResource();
}

/**
 * Utility interfaces
 */
export interface NoteInterface extends NoteAttributes, NoteBelongsTo {}
export interface NoteResource extends NoteInterface {}

/**
 * Resource methods
 */
export class NoteResource extends GenerateResource<NoteAttributes>({
  queryName: 'employers/notes',
  className: 'Note',
  AttributesClass: NoteAttributes,
  BelongsToClasses: [
    {
      Klass: NoteBelongsTo,
    },
  ],
}) {}

/**
 * Resource instance
 */
export const Note = APILibrary.createResource<NoteResource>(NoteResource);
